import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import PaymentForm from './PaymentForm';
import CartProp from '../../propTypes/CartProp';
import CategoryProp from '../../propTypes/CategoryProp';
import PackProp from '../../propTypes/PackProp';
import PlanProp from '../../propTypes/PlanProp';
import Cart from '../../navigation/Cart';
import StripePaymentMethodsProp from '../../../payments/propTypes/StripePaymentMethodsProp';
import BillingProp from '../../../profile/propTypes/billingProp';
import { SUBSCRIPTION_STATUSES } from '../../../../services/utilityFunctions';

function Payment({
  cart,
  subscriptionPaymentStatus,
  paymentSettings,
  paymentMethodsTypes,
  onFinish,
  onNavigate,
  showValidationErrors,
  postingForm,
  finishButtonText,
  plansAreFree,
  plans,
  categories,
  packs,
  billing,
  onPackRemove,
  onProductRemove,
  onSubscriptionRemove,
  onDiscountAdd,
  onDiscountRemove,
  isEdit,
  isResellerInstance,
  interval,
  taxRatePercentage,
  updatePaymentMethod,
  handleIsLoading,
}) {
  const formComponent = useRef(null);

  return (
    <div className="m-portlet__body" style={{ height: '100%' }}>
      <div className="subscription-payment-container">
        <div className="payment-cart-container">
          <Cart
            plansAreFree={plansAreFree}
            cart={cart}
            categories={categories}
            packs={packs}
            plans={plans}
            onPackRemove={onPackRemove}
            onProductRemove={onProductRemove}
            onSubscriptionRemove={onSubscriptionRemove}
            onDiscountRemove={onDiscountRemove}
            totalContainerClassName="payment-cart-total-container"
            totalLabelClassName="payment-cart-total-label"
            totalValueClassName="payment-cart-total-value"
            priceLabelClassName="payment-cart-price-label"
            priceValueClassName="payment-cart-price-value"
            interval={interval}
            taxRatePercentage={taxRatePercentage}
            isResellerInstance={isResellerInstance}
          />
        </div>
        <div className="payment-cc-form">
          <PaymentForm
            wrappedComponentRef={formComponent}
            subscriptionPaymentStatus={subscriptionPaymentStatus}
            showValidationErrors={showValidationErrors}
            plansAreFree={plansAreFree}
            cart={cart}
            categories={categories}
            plans={plans}
            paymentSettings={paymentSettings}
            paymentMethodsTypes={paymentMethodsTypes}
            finishButtonText={finishButtonText}
            onFinish={onFinish}
            onNavigate={onNavigate}
            postingForm={postingForm}
            onDiscountAdd={onDiscountAdd}
            isEdit={isEdit}
            isResellerInstance={isResellerInstance}
            billing={billing}
            updatePaymentMethod={updatePaymentMethod}
            handleIsLoading={handleIsLoading}
            taxRatePercentage={taxRatePercentage}
          />
        </div>
      </div>
    </div>
  );
}

Payment.propTypes = {
  subscriptionPaymentStatus: PropTypes.oneOf(SUBSCRIPTION_STATUSES).isRequired,
  paymentSettings: PropTypes.shape({
    paymentMethods: PropTypes.arrayOf(
      PropTypes.shape(StripePaymentMethodsProp.propType),
    ).isRequired,
    paymentMethodType: PropTypes.string.isRequired,
    paymentMethodId: PropTypes.string.isRequired,
    accountHolderName: PropTypes.string,
  }).isRequired,
  paymentMethodsTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  cart: PropTypes.shape(CartProp.propType).isRequired,
  finishButtonText: PropTypes.string.isRequired,
  onFinish: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  showValidationErrors: PropTypes.bool,
  postingForm: PropTypes.bool.isRequired,
  plansAreFree: PropTypes.bool.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  packs: PropTypes.arrayOf(PropTypes.shape(PackProp.propType)).isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape(PlanProp.propType)).isRequired,
  billing: PropTypes.shape(BillingProp.propType),
  onPackRemove: PropTypes.func.isRequired,
  onProductRemove: PropTypes.func.isRequired,
  onSubscriptionRemove: PropTypes.func.isRequired,
  onDiscountAdd: PropTypes.func.isRequired,
  onDiscountRemove: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isResellerInstance: PropTypes.bool.isRequired,
  interval: PropTypes.string.isRequired,
  taxRatePercentage: PropTypes.number.isRequired,
  updatePaymentMethod: PropTypes.func.isRequired,
  handleIsLoading: PropTypes.func.isRequired,
};

Payment.defaultProps = {
  showValidationErrors: false,
  billing: BillingProp.defaultProp,
};

export default translate(Payment);
